import type { NormalisedCampaign } from '@onhandtech/onhand-fe-shared/lib/api/v5/campaign/campaign.types'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { ContentPublishStatus } from 'constants/publish-status'

import { type CampaignModalType, type CampaignState, moduleName } from './campaigns.types'

const initialState: CampaignState = {
  activeFilterType: ContentPublishStatus.PUBLIC,
  selectedCampaign: null,
  draftCampaign: null,
  modals: {
    'delete-campaign': null,
    permissions: null,
    unpublish: null,
  },
  pagination: {
    pageNumber: 1,
  },
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setActiveFilterType: (state, action: PayloadAction<ContentPublishStatus>) => {
      state.activeFilterType = action.payload
      state.pagination.pageNumber = 1
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pagination.pageNumber = action.payload
    },
    setSelectedCampaign: (state, action: PayloadAction<NormalisedCampaign | null>) => {
      state.selectedCampaign = action.payload
      state.draftCampaign = action.payload ? { ...action.payload } : null
    },
    setDraftCampaign: (state, action: PayloadAction<NormalisedCampaign | null>) => {
      state.draftCampaign = action.payload
    },
    setCampaignModal: (
      state,
      {
        payload: { type, campaign },
      }: PayloadAction<{
        type: CampaignModalType
        campaign: NormalisedCampaign | null
      }>,
    ) => {
      state.modals[type] = campaign
    },
  },
})

export default slice
